import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import DataGridComponent from "../../Components/DataGridComponent";
import { errorAlert } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { FixedAssetsHeader } from "./GridHeaders/FixedAssetsHeader";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { assetColumns, assetMappings } from "../../Components/ExcelConverter/FinancialStatement";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";


export default function FixedAssets() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    // Kodi per Marrjen e informatave nga databaza

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'FinanceStatement/FixedAssert', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
            // setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const brutoTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.VleraBruto), 0);
    }, [data]);

    const zhvlersimiTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Zhvleresimi), 0);
    }, [data]);

    const netoTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.VleraNeto), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        accname: item.Emertimi,
        date: item.Date,
        vleraBruto: item.VleraBruto,
        zhvlersimi: item.Zhvleresimi,
        vleraNeto: item.VleraNeto,
    }));


    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            <TitleElements
                icon={SiHyperledger}
                title="Mjetet themelore"
            />
            <ElementsParagraph text="Raporti për mjetet themelore gjatë një viti fiskal." />
            <hr></hr>
            <ExcelFormat
                data={data}
                fileName={`Mjetet themelore`}
                columns={assetColumns}
                columnMappings={assetMappings}
                buttonText="XLSX"
            />
            <DataGridComponent columns={FixedAssetsHeader} rows={rows} />
            <TotalSummaryComponent
                fields={[
                    { id: 1, label: 'Vlera Bruto', value: brutoTotal },
                    { id: 2, label: 'Zhvlersimi', value: zhvlersimiTotal },
                    { id: 3, label: 'Vlera Neto', value: netoTotal },
                ]}
            />
        </div>
    )
}